import React, { useMemo } from 'react';

import { AgGridReact } from 'ag-grid-react';

export const FilesTable = ({tableSize, fileTableConfiguration}) => {
    const {gridId, defaultPageSize, pageSizeOptions, colDefs, onGridReady, rowSelectionChanged, gridRef} = fileTableConfiguration;

    const defaultColDef = useMemo(() => {
        return {
          flex: 1
        };
      }, []);
    const autoSizeStrategy = {
        type: 'fitGridWidth',
    };
    
    const rowSelection = useMemo(() => {
        return {
            mode: "multiRow",
        };
    }, []);
    
    return(
        <div id={gridId} className={`ag-theme-quartz ${tableSize}`}>
            <AgGridReact
                suppressClickEdit={true}
                ref = {gridRef}
                pagination={true}
                columnDefs={colDefs}
                defaultColDef={defaultColDef}
                rowSelection= {rowSelection}
                rowModelType={'infinite'}
                onGridReady={onGridReady}
                onSelectionChanged={rowSelectionChanged}
                paginationPageSize={defaultPageSize}
                paginationPageSizeSelector={pageSizeOptions}
                cacheBlockSize={defaultPageSize}
                cacheOverflowSize={2}
                maxConcurrentRequests={2}
                infiniteInitialRowCount={1}
                maxBlocksInCache={1}
            />
        </div>
    )
}